<template>
  <div
    v-show="!isClose && imgUrl"
    style="position: fixed; bottom: 335px; right: 30px; z-index: 20"
  >
    <a
      target="_blank"
      rel="noopener"
      @click="goto()"
    >
      <img
        :src="imgUrl"
        class="float-icon"
        alt="float-icon"
      >
    </a>
    <i
      class="icon-cancel"
      aria-hidden="true"
      @click="closeClick"
    />
  </div>
</template>

<script>
import { googleFormTransform } from '@/js/utils'
export default {
  data () {
    return {
      imgUrl: '',
      linkUri: '',
      isClose: false
    }
  },
  mounted () {
    if (sessionStorage.getItem('isFloatIconClose')) {
      this.isClose = true
      return
    }
    this.getData()
  },
  methods: {
    async getData () {
      try {
        const res = await this.$getAPI(`${process.env.VUE_APP_CORE_URL}/api/ActiveIcon/GetActiveIcon`)
        const iconArr = _cloneDeep(res)
        if (iconArr.length) {
          const processedUrl = googleFormTransform.fetchURL(iconArr[0].uri)
          this.imgUrl = iconArr[0].img_uri
          this.linkUri = processedUrl
          console.log(res)
        }
      } catch (e) {
        console.log(e)
      }
    },
    closeClick () {
      sessionStorage.setItem('isFloatIconClose', true)
      this.isClose = true
    },
    goto () {
      window.open(this.linkUri, '_blank')
    }
  }
}
</script>

<style lang="sass" scoped>
.float-icon
  width: 80px
  height: 80px
  margin-left: -20px
  color: white
  text-align: center
  line-height: 1
  transform: translate3d(0, 0, 0)
  transition: transform ease-out 200ms
  z-index: 20
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  font-size: 24px
  font-weight: bold
  &:hover
    transform: scale(1.2, 1.2) translate3d(0, 0, 0)
.icon-cancel
  position: absolute
  top: -5px
  right: -7px
  cursor: pointer
  z-index: 21
</style>
